import { useEffect, useState } from "react";
import {
  FDWAntragsteller,
  FDWResultEntry,
} from "../../../restfd2/fdw_result.ts";
import { QuestionizerResultItem } from "./questionizer-result-result-item.tsx";

export function QuestionizerAccordion(props: {
  active: boolean;
  regions: Record<string, { region: string; list: Array<FDWResultEntry> }>;
}) {
  return (
    <div className="accordion">
      {props.active &&
        Object.keys(props.regions).map((key: string) => {
          const region = props.regions[key];

          return (
            <div className="accordion__element" key={key}>
              <h3
                className="accordion__element_title"
              >
                <span>
                  <b>{region.region}</b>
                </span>
              </h3>
              {region.list.map((entry: FDWResultEntry) => (
                  <QuestionizerResultItem key={entry.fp_id} entry={entry} />
                ))}
            </div>
          );
        })}
    </div>
  );
}